import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from './divider.styles.js';

var _excluded = ["width", "design"];
var Divider = function Divider(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width,
      _props$design = props.design,
      design = _props$design === void 0 ? 'primary' : _props$design,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React__default.createElement(Box, _extends({
    role: "separator",
    dividerWidth: width,
    design: design
  }, attrs));
};

export { Divider };
